'use client'

import type { Address, ChainId } from '@morpho-org/blue-sdk'

import { createContext, type PropsWithChildren, use } from 'react'

export interface VaultRoute {
  chainId: ChainId
  address: Address
  isVaultV2: boolean
  name: string | null
  description: string | null
}

const VaultRouteContext = createContext<VaultRoute | null>(null)

/**
 * The vault the segment layout resolved, for the route `loading.tsx`, which Next renders
 * inside that layout but without its data.
 */
export const VaultRouteProvider = ({
  chainId,
  address,
  isVaultV2,
  name,
  description,
  children
}: PropsWithChildren<VaultRoute>) => {
  const value = { chainId, address, isVaultV2, name, description }
  return <VaultRouteContext value={value}>{children}</VaultRouteContext>
}

export const useVaultRoute = () => {
  return use(VaultRouteContext)
}
